export default "__VITE_ASSET__e51e63d6__"